// src/Projects.js
import React, { useEffect, useState } from "react";
import { IonIcon } from "@ionic/react";
import { openOutline } from "ionicons/icons";
import "./skeleton.css";

const ProjectSkeleton = () => (
  <div className="projects-grid">
    {[1, 2, 3, 4].map((index) => (
      <div key={index} className="project-card skeleton-wrapper">
        <div style={{ padding: "24px" }}>
          <div className="skeleton-image" style={{ marginBottom: 16 }}></div>
          <div className="skeleton-title"></div>
          <div className="skeleton-text" style={{ marginTop: 8 }}></div>
          <div className="skeleton-text" style={{ width: "60%", marginTop: 8 }}></div>
          <div className="skeleton-button"></div>
        </div>
      </div>
    ))}
  </div>
);

const AIRTABLE_API_KEY = process.env.REACT_APP_AIRTABLE_API_KEY;
const AIRTABLE_BASE_ID = process.env.REACT_APP_AIRTABLE_BASE_ID;

const Projects = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRecords = async () => {
      try {
        const response = await fetch(
          `https://api.airtable.com/v0/${AIRTABLE_BASE_ID}/Projects?sort[0][field]=created_time&sort[0][direction]=desc`,
          {
            headers: {
              Authorization: `Bearer ${AIRTABLE_API_KEY}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch records");
        }
        const data = await response.json();
        setRecords(data.records);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching records:", error);
        setError(error.message);
        setLoading(false);
      }
    };

    fetchRecords();
  }, []);

  if (loading) return <ProjectSkeleton />;
  if (error) return <div className="error-message">Error: {error}</div>;

  // Split records into featured and regular projects
  const featuredProjects = records.filter(
    (record) => record.fields.custom_class === "golden"
  );
  const regularProjects = records.filter(
    (record) => record.fields.custom_class !== "golden"
  );

  return (
    <>
      {featuredProjects.length > 0 && (
        <div className="space-section">
          <h2>Featured</h2>
          <div className="projects-grid">
            {featuredProjects.map((record) => (
              <div
                key={record.id}
                className="project-card space-theme"
              >
                <div className="space-badge">
                  <span className="star">&#9733;</span> Featured
                </div>
                <div className="project-card-header">
                  {record.fields.img_url && (
                    <div className="project-card-image-container">
                      <img
                        className="project-card-img"
                        src={record.fields.img_url}
                        alt={record.fields.project_name}
                      />
                    </div>
                  )}
                  <h3 className="project-card-title">
                    {record.fields.project_name}
                  </h3>
                </div>
                <div className="project-card-content">
                  <p
                    className={
                      `project-card-desc` +
                      (record.fields.custom_class_p
                        ? ` ${record.fields.custom_class_p}`
                        : "")
                    }
                  >
                    {record.fields.p}
                  </p>
                </div>
                {record.fields.button_link && record.fields.button && (
                  <div className="project-card-footer">
                    <a
                      href={record.fields.button_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="project-card-link"
                    >
                      <button className="project-card-btn space-btn">
                        <span>{record.fields.button}</span>
                        <IonIcon icon={openOutline} className="btn-icon" />
                      </button>
                    </a>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="projects-grid">
        {regularProjects.map((record) => (
          <div
            key={record.id}
            className={`project-card ${record.fields.custom_class || ""}`}
          >
            <div className="project-card-header">
              {record.fields.img_url && (
                <div className="project-card-image-container">
                  <img
                    className="project-card-img"
                    src={record.fields.img_url}
                    alt={record.fields.project_name}
                  />
                </div>
              )}
              <h3 className="project-card-title">
                {record.fields.project_name}
              </h3>
            </div>
            <div className="project-card-content">
              <p
                className={
                  `project-card-desc` +
                  (record.fields.custom_class_p
                    ? ` ${record.fields.custom_class_p}`
                    : "")
                }
              >
                {record.fields.p}
              </p>
            </div>
            {record.fields.button_link && record.fields.button && (
              <div className="project-card-footer">
                <a
                  href={record.fields.button_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-card-link"
                >
                  <button className="project-card-btn">
                    <span>{record.fields.button}</span>
                    <IonIcon icon={openOutline} className="btn-icon" />
                  </button>
                </a>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default Projects;
